import React from 'react'
import GenericModal from "../../../../components/modal/GenericModal";

const ConfirmarActualizar = ({ toggleModal,  handleUpdateFromPreview }) => {

  const update = async () => {
    toggleModal();
    await handleUpdateFromPreview();
  };

  return (
    <GenericModal
      titulo="Confirmar Actualizar"
      showModal={toggleModal}
      width={"600px"}
    >
      <div className="modal-body pt-0 pl-0">
        <p>
          Guarde los cambios antes de ver el Preview.
        </p>
      </div>
      <div className="modal-footer justify-content-end">
        <button
          className="btn btn-primary generic-button-ficha mr-2"
          onClick={update}>
          Actualizar
        </button>
        <button
          className="btn btn-primary generic-button-ficha"
          onClick={() => { toggleModal() }}>
          Cancelar
        </button>
      </div>
    </GenericModal>
  )
}

export default ConfirmarActualizar